module.exports = __webpack_public_path__ + "img/xyj.54e52200.png";